import FetchJson from "./fetchJson";

export default class FetchMediaObject extends FetchJson {
  post(path, data, options = {}) {
    return this.call(path, {
      ...options,
      method: "POST",
      body: data,
    });
  }

  async call(path, options = {}) {
    try {
      let { data } = await super.call(path, options);

      return data;
    } catch ({ status, message, data, description }) {
      return Promise.reject({
        description,
        message,
        status,
        ...{
          message: data["hydra:title"],
          errors: data.violations
            ? data.violations.reduce(
                (o, error) => ({
                  ...o,
                  [error.propertyPath]: [...(o[error.propertyPath] || []), error.message],
                }),
                {},
              )
            : {},
        },
      });
    }
  }
}
